import { Skeleton } from '@otter-ai/den-components';

type PriceSkeletonProps = {
  sessionIsUpdating: boolean;
  children: React.ReactNode;
  className?: string;
};

export function PriceSkeleton({
  sessionIsUpdating,
  children,
  className = 'h-4 my-0',
}: PriceSkeletonProps) {
  if (sessionIsUpdating) {
    return <Skeleton className={className} />;
  }
  return <>{children}</>;
}

type AutoRenewSkeletonProps = {
  sessionIsUpdating: boolean;
  children: React.ReactNode;
};

export function AutoRenewSkeleton({
  sessionIsUpdating,
  children,
}: AutoRenewSkeletonProps) {
  if (sessionIsUpdating) {
    return <Skeleton className="h-4 my-0 w-80" />;
  }
  return <>{children}</>;
}
